import React from 'react';

export default function BotaoSublinhado(props) {
  //props.largura: Define a largura do botão
  //props.alinhamento: Tipo de alinhamento
  //props.tamanhoFonte: Tamanho da fonte
  //props.clicado: Evento de clique
  //props.nome : Texto do botão
  return (
    <div
      style={{
        width: props.largura,
        textAlign: props.alinhamento,
        alignItems: 'flex-end',
        marginLeft: props.left ? props.left : 0,
      }}
    >
      <button
        style={{
          color: '#005288',
          fontFamily: 'montserrat',
          border: 'none',
          borderBottom: '1px solid #005288',
          backgroundColor: 'transparent',
          margin: 0,
          padding: 0,
          fontSize: props.tamanhoFonte ? props.tamanhoFonte : 16,
          fontWeight: 500,
          cursor: 'pointer',
        }}
        onClick={() => {
          props.clicado();
        }}
      >
        {props.nome}
      </button>
    </div>
  );
}
